import { Component, OnInit } from '@angular/core';
import {InspectionOrder} from "../../../classes/inspectionOrder";
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {InspectionOrderService} from "../../../services/inspectionOrder";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-inspection-order-update',
  templateUrl: './inspection-order-update.component.html',
  styleUrls: ['./inspection-order-update.component.css']
})
export class InspectionOrderUpdateComponent implements OnInit {

  inspectionOrder = new InspectionOrder();
  inspectionOrderCreationResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private inspectionOrderService: InspectionOrderService) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.inspectionOrderService.getByID(params.get('id'))
          .subscribe({
            next: (inspectionOrder: any) => {
              this.inspectionOrder = inspectionOrder;
            },
            error: (err: HttpErrorResponse) => {
              console.log(err);
            }
          });
    });
  }

  onSubmit() {
    this.inspectionOrderService.update(this.inspectionOrder)
        .subscribe({
          next: () => {
            this.router.navigate(['/inspection/order/' + this.inspectionOrder.id_inspection_order]);
          },
          error: (err: HttpErrorResponse) => {
            this.inspectionOrderCreationResult = false;
            console.log(err);
          }
        });
  }

}
